import { useQuery } from "@tanstack/react-query";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { Link } from "react-router-dom";
import { getGiftCardsAdmin } from "../../../network/admin";
import AntTable from "../../AntTable/AntTable";
type Props = {
  isFilter: any;
  selectedRowKeys: any;
  setSelectedRowKeys: any;
  searchHeader: any;
};

const TabGiftCard = ({
  isFilter,
  selectedRowKeys,
  setSelectedRowKeys,
  searchHeader,
}: Props) => {
  const [page, setPage] = useState<number>(1);
  const { data, isLoading, isFetching } = useQuery(
    ["giftcard", page, isFilter, searchHeader],
    () => getGiftCardsAdmin({ page, ...isFilter, search: searchHeader })
  );

  const columns: ColumnsType<any> = [
    {
      title: <div className="text-[#9999A7] text-sm font-normal">#</div>,
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary">
          {record?.id}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon
        </div>
      ),
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary" dir="ltr">
          {record?.salon?.name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Card vale</div>
      ),
      dataIndex: "display_all_booking",

      render: (text: any, record) => (
        <div className="text-[#9999A7] text-sm font-medium">
          <span className="flex items-center mx-1 font-semibold text-color-primary">
            {record?.values?.map((e: number) => (
              <div className="mx-1">
                <span>{e}</span>
                <small className="text-color-primary text-[8px]">SR</small>
              </div>
            ))}
          </span>
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Status</div>,
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-[#9999A7]">
          <span
            className={`text-sm font-medium ${
              record?.available_sale !== "in_store_only"
                ? "!text-[#479821]"
                : "!text-[#020418]"
            }`}
          >
            {record?.available_sale === "in_store_only" ? "Offline" : "Online"}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Expiry period</div>
      ),
      dataIndex: "Expiry_period",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={`text-sm text-color-primary font-medium flex items-center w-full justify-between`}
        >
          {record?.voucher_duration?.days_difference}
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <Link
          className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer"
          to={`${record?.name}`}
        >
          <AiOutlineEdit />
        </Link>
      ),
    },
  ];
  return (
    <div>
      <AntTable
        tableColumns={columns}
        tableData={data?.data}
        isLoading={isLoading}
        expandRowByClick={false}
        // hideArrowExpand
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        selectionType={selectedRowKeys}
        setPage={setPage}
        page={page}
        total={data?.meta?.total}
      />
    </div>
  );
};

export default TabGiftCard;
